import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { useAdsStyles } from '../../../../../util/styles/hooks/useAdsStyles.js';
import { isTouchDevice } from '@drone-js/media-query';
import { mergeRefs } from '@react-aria/utils';
import { fadeOption, getFadeGradients } from '../../../../Carousel/helpers/fadeGradiant.js';
import { useCarouselV3Context } from '../../../hooks/useCarouselV3Context.js';
import { useDirectionContext } from '../../../../../contexts/session/Locale.js';

var _excluded = ["fade", "height"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useContainer = function useContainer(props, ref) {
  var _useCarouselV3Context = useCarouselV3Context(),
    carouselRef = _useCarouselV3Context.carouselRef,
    gap = _useCarouselV3Context.gap,
    canScrollNext = _useCarouselV3Context.canScrollNext,
    canScrollPrev = _useCarouselV3Context.canScrollPrev;
  var fade = props.fade,
    height = props.height,
    rest = _objectWithoutProperties(props, _excluded);
  var direction = useDirectionContext();
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var hasTouchSupport = isTouchDevice();
  var isRtl = direction === 'rtl';
  var mergedRef = mergeRefs(carouselRef, ref);
  var fadeStyled = !hasTouchSupport && fade && fadeOption(canScrollPrev, canScrollNext);
  var fadeGradients = fadeStyled ? getFadeGradients(true, fadeStyled, isRtl) : undefined;
  var getMarginStart = React.useCallback(function (ms) {
    if (ms === '0') {
      return '0';
    }
    return "-".concat(ms);
  }, []);
  var styles = mapAdsStyles({
    display: 'flex',
    height: height,
    ms: gap ? getMarginStart(gap) : undefined
  });
  var carouselContainerStyles = mapAdsStyles({
    overflow: 'hidden',
    height: height,
    maskImage: fadeGradients
  });
  var outerContainerProps = _objectSpread(_objectSpread({
    ref: mergedRef,
    role: 'region',
    tabIndex: 0
  }, carouselContainerStyles), rest);
  var innerContainerProps = _objectSpread({
    'aria-live': 'polite'
  }, styles);
  return {
    outerContainerProps: outerContainerProps,
    innerContainerProps: innerContainerProps
  };
};

export { useContainer };
//# sourceMappingURL=useContainer.js.map
